
import * as TX from 'app/calcs/Accountant/Transactions/interfaces'
import { binByIncomeAndExpenses, groupByFractionalYears, makeGroupByMultipleYears, nameByMonthAndYear, nameByTwoYears, nameByYear } from 'app/calcs/Accountant/Transactions/predicates'
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'

function pointFormatter() {
  return this.x + ' Average Monthly ' + this.series.name + ': <b>' + utils.toCurrency(this.point.y) + '</b>'
}

function yAxisLabeller() {
  return utils.toCurrency(this.value, false)
}

const yearlyColumnChartConfig = {
  title: {
    text: 'Summary of monthly income / expenses by year'
  },
  xAxis: {
    categories: []
  },
  yAxis: {
    labels: {
      formatter: yAxisLabeller
    },
    lineWidth: 1,
    tickWidth: 1,
    title: {
      text: undefined
    }
  },
  credits: {
    enabled: false
  },
  tooltip: {
    formatter: pointFormatter
  },
  series: []
}

function getYearlyColumnChartConfig(items: TX.ITransactionItem[]): any {
  yearlyColumnChartConfig.xAxis.categories = []
  yearlyColumnChartConfig.series = [
    { name: 'Income', type: 'column', data: [], color: '#8dc248' },
    { name: 'Expenses', type: 'column', data: [], color: '#e51c23' }
    // RA-131 { name: 'Cumulative Balance', type: 'line', data: [], color: '#333', lineWidth: 4 }
  ]
  const firstYear = (!items || 0 === items.length) ? 0 : items[0].when.year()

  // every 2 years
  const clumpLengthYears = 2
  const clumper = (tx: TX.ITransactionItem): number => Math.floor((tx.when.year() - firstYear) / 2)
  const clumpNamer = nameByTwoYears

  // by year
  //const clumpLengthYears = 2
  //const clumper = makeGroupByMultipleYears(clumpLengthYears)
  //const clumpNamer = nameByYear

  // by month
  //const clumper = groupByFractionalYears
  //const clumpNamer = nameByMonthAndYear

  const groups = _.groupBy(items, clumper)

  return _(items)
    .groupBy(clumper)
    .map(binByIncomeAndExpenses(clumpNamer))
    .reduce((config, clump) => {
      const months = clump.latestDate.diff(clump.earliestDate, 'months', true) + 1
      // tslint:disable-next-line:no-console
      console.log(clump.clumpName + ' income: ' + clump.income + ', months: ' + months)
      // tslint:disable-next-line:no-console
      console.log('earliest: ' + clump.earliestDate.format('L LTS') + ', latest: ' + clump.latestDate.format('L LTS') + ', months: ' + months)
      config.series[0].data.push(clump.income / months)
      config.series[1].data.push(clump.expenses / months)
      // RA-131 config.series[2].data.push(clump.balance / clumpLengthYears)
      config.xAxis.categories.push(clump.clumpName)
      return config
    }, yearlyColumnChartConfig)
}

export {
  getYearlyColumnChartConfig
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Results/charts/yearlyColumn/index.ts